import { render } from "./SortIcons.vue?vue&type=template&id=11aa065a&scoped=true"
import script from "./SortIcons.vue?vue&type=script&lang=js"
export * from "./SortIcons.vue?vue&type=script&lang=js"

import "./SortIcons.vue?vue&type=style&index=0&id=11aa065a&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11aa065a"]])

export default __exports__